"use client";
import * as prismic from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

import { Swiper, SwiperSlide } from "swiper/react";
import { sliderTestimonialCenter } from "@/utils/swiperOptions";

const Testimonials = ({ slice }) => {
  const eyebrow =
    prismic.asText(slice?.primary?.eyebrow) || "Client Testimonials";
  const title =
    prismic.asText(slice?.primary?.title) || "What Our Clients Are Saying";
  const description = slice?.primary?.description;
  const testimonials = slice?.primary?.testimonials || [];
  const sliderOptions = {
    ...sliderTestimonialCenter,
    centeredSlides: false, // keep slides fully visible at the edges
    loop: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.05,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 1.3,
        spaceBetween: 18,
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
      1536: {
        slidesPerView: 4,
        spaceBetween: 28,
      },
    },
  };

  const renderStars = (rating) => {
    const value = Number(rating);
    const clamped = Number.isFinite(value)
      ? Math.max(0, Math.min(5, Math.round(value)))
      : 5;

    return Array.from({ length: 5 }).map((_, idx) => (
      <i
        key={idx}
        className="icon-favorite_major"
        style={{ opacity: idx < clamped ? 1 : 0.3 }}
      />
    ));
  };

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <section className="section-testimonials bg-1 home-page-3 tf-spacing-1 pr-8 pl-8">
        <div className="w-full">
          <div className="heading-section">
            <p
              className="text-2 sub wow fadeInUp"
              data-wow-duration={1000}
              data-wow-delay="0s"
            >
              {eyebrow}
            </p>
            <h3
              className="wow fadeInUp"
              data-wow-duration={1000}
              data-wow-delay="0s"
            >
              {title}
            </h3>
            {description ? (
              <div
                className="description text-1 lh-30 wow fadeInUp"
                data-wow-duration={1000}
                data-wow-delay="0s"
              >
                <PrismicRichText field={description} />
              </div>
            ) : null}
          </div>
          {testimonials.length > 0 ? (
            <Swiper
              {...sliderOptions}
              className="swiper-container slider-testimonial-center"
            >
              <div className="swiper-wrapper">
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={`testimonial-${index}`}>
                    <div className="wg-testimonial style-text-center">
                      <div className="rating">
                        {renderStars(testimonial.rating)}
                      </div>
                      <div className="content">
                        <div className="text text-1 lh-30 fw-4 mb-16">
                          <PrismicRichText field={testimonial.quote} />
                        </div>
                        <div className="bot">
                          <div className="info">
                            {testimonial.author_name ? (
                              <h3 className="title text-3xl leading-tight font-semibold">
                                {testimonial.author_name}
                              </h3>
                            ) : null}
                            {testimonial.author_location ? (
                              <p>{testimonial.author_location}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </div>
            </Swiper>
          ) : null}
        </div>
      </section>
    </section>
  );
};

export default Testimonials;
